const DEFAULT_SPECIALISATION_COLOR_CODE = "#ECFDF3";
const SPECIALISATIONS = {
  GERIATRIC_DENTISTRY: {
    translationKey: "specialisation.GERIATRIC_DENTISTRY",
    colorCode: "#FEF0C7"
  },
  ALIGNER_THERAPIE: {
    translationKey: "specialisation.ALIGNER_THERAPIE",
    colorCode: "#D1E9FF"
  },
  SPORT_DENTISTRY: {
    translationKey: "specialisation.SPORT_DENTISTRY",
    colorCode: "#E3FBCC"
  },
  PEDIATRIC_DENTISTRY: {
    translationKey: "specialisation.PEDIATRIC_DENTISTRY",
    colorCode: "#FEF7C3"
  },
  MICROBIOLOGICAL_THERAPY: {
    translationKey: "specialisation.MICROBIOLOGICAL_THERAPY",
    colorCode: "#DCE8FF"
  },
  ORAL_SURGERY: {
    translationKey: "specialisation.ORAL_SURGERY",
    colorCode: "#E0F2FE"
  },
  ANXIETY: {
    translationKey: "specialisation.ANXIETY",
    colorCode: "#DCE8FF"
  },
  IMPLANTOLOGY: {
    translationKey: "specialisation.IMPLANTOLOGY",
    colorCode: "#D1FADF"
  },
  LAUGHING_GAS: {
    translationKey: "specialisation.LAUGHING_GAS",
    colorCode: "#CFF9FE"
  },
  ORTHODONTICS: {
    translationKey: "specialisation.ORTHODONTICS",
    colorCode: "#FEF0C7"
  },
  CMD: {
    translationKey: "specialisation.CMD",
    colorCode: "#E3FBCC"
  },
  DENTURES: {
    translationKey: "specialisation.DENTURES",
    colorCode: "#FBE8FF"
  },
  BOTOX: {
    translationKey: "specialisation.BOTOX",
    colorCode: "#D1FADF"
  },
  PERIODONTOLOGY: {
    translationKey: "specialisation.PERIODONTOLOGY",
    colorCode: "#EBE9FE"
  },
  TEETH_PRESERVATION: {
    translationKey: "specialisation.TEETH_PRESERVATION",
    colorCode: "#FBE8FF"
  },
  CEREC: {
    translationKey: "specialisation.CEREC",
    colorCode: "#CFF9FE"
  },
  AESTHETIC_DENTISTRY: {
    translationKey: "specialisation.AESTHETIC_DENTISTRY",
    colorCode: "#FFEAD5"
  },
  ENDODONTOLOGY: {
    translationKey: "specialisation.ENDODONTOLOGY",
    colorCode: "#CCFBEF"
  },
  BIOLOGICAL_DENTISTRY: {
    translationKey: "specialisation.BIOLOGICAL_DENTISTRY",
    colorCode: "#ECFDF3"
  }
};
export {
  DEFAULT_SPECIALISATION_COLOR_CODE,
  SPECIALISATIONS
};
